import moment from 'moment';

const FORMATO = 'YYYY-MM-DD';

const sumarDias = (fecha, dias) => moment(fecha, FORMATO).add(dias, 'days').format(FORMATO);

export const limitesDeFechas = (formData, hoy) => {
    var inicio = formData.fecha_inicio;
    var fin = formData.fecha_fin;

    return {
        inicioMin: sumarDias(hoy, 1),
        finMin: inicio ? sumarDias(inicio, 2) : undefined,
        publicacionMin: inicio ? sumarDias(inicio, 1) : undefined,
        publicacionMax: fin ? sumarDias(fin, -1) : undefined,
    };
};

export const aplicarCambioDeFecha = (formData, campo, valor) => {
    var next = Object.assign({}, formData);
    next[campo] = valor;
    if (campo === 'fecha_inicio') {
        next.fecha_fin = '';
        next.fecha_limite_publicacion = '';
    }
    if (campo === 'fecha_fin') {
        next.fecha_limite_publicacion = '';
    }
    return next;
};
